<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="UID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入UID"></el-input>
					</el-form-item>
                    <el-form-item label="用户名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="订单编号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderSn" placeholder="请输入订单编号">
						</el-input>
					</el-form-item>
					<el-form-item label="联盟门店:" label-width="80px">
						<el-select v-model="searchInfo.brandId" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="3" label="拼多多" :value="3">拼多多</el-option>
							<el-option key="4" label="京东" :value="4">京东</el-option>
							<el-option key="14" label="唯品会" :value="14">唯品会</el-option>
							<el-option key="22" label="抖音" :value="22">抖音</el-option>
							<el-option key="32" label="淘宝" :value="32">淘宝</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="订单状态:" label-width="80px">
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待付款" :value="0">待付款</el-option>
							<el-option key="1" label="已付款" :value="1">已付款</el-option>
							<el-option key="2" label="待结算" :value="2">待结算</el-option>
							<el-option key="3" label="已结算" :value="3">已结算</el-option>
							<el-option key="4" label="无效订单" :value="4">无效订单</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
							 start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="orderList" stripe style="width: 100%" border>
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
            <!-- <el-table-column prop="id" align="center" width="90" label="#">
			</el-table-column> -->
			<el-table-column prop="" label="用户" align="center" width="150" :show-overflow-tooltip="true">
                 <template slot-scope="scope">
                    <span >{{ scope.row.userId }}</span>
					<span v-if="scope.row.username"> ~ {{ scope.row.username }}</span>
				</template>
			</el-table-column>
            <el-table-column prop="" label="联盟门店" align="center" width="90" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.brandId==3">拼多多</span>
					<span v-if="scope.row.brandId==4">京东</span>
					<span v-if="scope.row.brandId==14">唯品会</span>
					<span v-if="scope.row.brandId==22">抖音</span>
                    <span v-if="scope.row.brandId==32">淘宝</span>
				</template>
            </el-table-column>
			<el-table-column prop="actName" label="活动" align="center" width="130" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="storeName" label="销售商家" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="orderSn" label="订单编号" align="center" width="200" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="orderTitle" label="商品名称" align="center" min-width="120" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderPrice" label="订单总价(￥)" align="center" width="120" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="statusDesc" label="订单状态" align="center" width="120" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="status" label="订单状态" align="center" width="90" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.status==0" style="color:#E6A23C;">待付款</span>
					<span v-if="scope.row.status==1" style="color:#409EFF;">已付款</span>
					<span v-if="scope.row.status==2" style="color:#9042bd;">待结算</span>
					<span v-if="scope.row.status==3" style="color:#67C23A;">已结算</span>
                    <span v-if="scope.row.status==4" style="color:#909399;">无效订单</span>
				</template>
            </el-table-column>
			<el-table-column prop="rewardIntegralNumber" label="送流量池" align="center" width="80" :show-overflow-tooltip="true">
                <!-- <template slot-scope="scope">
                    <span >{{ scope.row.rewardIntegralNumber.toFixed(2) }}</span>
				</template> -->
            </el-table-column>
			<el-table-column prop="jtkShareRate" label="佣金比例" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="jtkShareFee" label="佣金" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="下单时间" align="center" width="180" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="payTime" label="付款时间" align="center" width="180" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="180" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="" label="详情" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row)">查看</el-button>
				</template>
			</el-table-column> -->

		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px;" background :current-page="sliderlist.pageNum" @current-change="pageChange"
		 layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 订单详情对话框 -->
		<el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%" :before-close="handleClose" :close-on-click-modal="false">
			<div>
				<div style="margin:10px 0 ;">商品详情</div>
				<div class="orderList">

					<div class="orderxq" v-for="(item,index) in orderInfo.ssStoreOrderGoodsDtos" :key="index">
						<div>
							<img :src="item.images.split(',')[0]" alt="" style="width:100px;height:100px;">
						</div>
						<div style="margin-left:20px;">
							<p>{{item.goodsName}}</p>
							<p>购买数量：{{item.num}}</p>
							<p>单价：{{item.price}}</p>
						</div>

					</div>

				</div>
				
				<el-form v-model="orderInfo" label-position="left" inline class="demo-table-expand">
					<el-form-item label="订单号">
						<span>{{orderInfo.orderCode}}</span>
					</el-form-item>
					
					<el-form-item label="支付类型">
						<span v-if="orderInfo.payType=='wx'">微信支付</span>
						<span v-if="orderInfo.payType=='alipay'">支付宝支付</span>
						<span v-if="orderInfo.payType=='integral'">积分抵扣-{{orderInfo.integralName}}</span>
						<span v-if="orderInfo.payType=='wxplural'">微信积分混合支付</span>
						<span v-if="orderInfo.payType=='aliplural'">支付宝混合支付</span>
					</el-form-item>

					
				
					<el-form-item label="订单状态">
						<span v-if="orderInfo.status==1">待核销</span>
						<!-- <span v-if="orderInfo.status==2">待收货</span> -->
						<span v-if="orderInfo.status==3">已完成</span>
					</el-form-item>
					<el-form-item label="订单总价">
						<span>￥{{orderInfo.orderTotalPrice}}</span>
					</el-form-item>
					<el-form-item label="用户">
						<span>{{orderInfo.username}}</span>
					</el-form-item>
					<el-form-item label="联系电话">
						<span>{{orderInfo.phone}}</span>
					</el-form-item>
					
					<el-form-item label="支付时间">
						<span>{{orderInfo.payTime}}</span>
					</el-form-item>
					<el-form-item label="核销时间" v-if="orderInfo.hxDatetime">
						<span>{{orderInfo.hxDatetime}}</span>
					</el-form-item>
					<el-form-item label="完成时间" v-if="orderInfo.completeTime">
						<span>{{orderInfo.completeTime}}</span>
					</el-form-item>
				
					
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

		
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				orderList: [],
				dialogVisible: false,
				loading:false,
				editDialogVisible: false,
				searchInfo: {
					brandId: '',
                	status: ''
				},
				orderInfo: {},
				sliderlist: {},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				sysExpressList: [],
				storeOrder: {},
				shipments_orderCode:'',
				shipments_name:'',
				shipments_address:'',
				expressType:'',
				ExpDialog: false , //查看物流弹窗
				wudetail:[{}], //查看物流数据

				storeFlage: false,
			};
		},
		methods: {
			lookexp(id){ //查看物流
				this.$api.lookExpress(id).then(res=>{
					if(res.state=='success'){
						this.ExpDialog=true
						this.wudetail=JSON.parse(res.data.detail).reverse()
					}else{
						this.$message.error(res.message);
					}
				})
			},
			shipmentsClick(item){ //表格点击发货
				// console.log('点击的表格数据---',item)
				this.storeOrder = {};	
				this.storeOrder.id = item.id;
				this.storeOrder.status = 2;
				this.storeOrder.storeId = item.storeId;
				this.shipments_orderCode = item.orderCode;
				this.shipments_address = item.address;
				this.expressType = '';
				this.$api.findOrderInfo(item.id).then((res) => { //查询订单详情
					if (res.state == 'success') {
						this.shipments_name = res.data.name+"-"+res.data.phone;
						this.editDialogVisible = true;
					}
				})
				
			},
			shipments() {
				this.loading=true
				let data={}
				if(this.expressType==2){ //自提
					data = {
						sendRemark: this.storeOrder.sendRemark,
						expressId: 1,
						storeId: this.storeOrder.storeId,
						status: 3,
						id: this.storeOrder.id
					}
				}else{ //快递
					data = {
						expressCode: this.storeOrder.expressCode,
						sendRemark: this.storeOrder.sendRemark,
						// sendOpUser: this.sendOpUser,//发货人
						expressId: this.storeOrder.expressId,
						storeId: this.storeOrder.storeId,
						status: 2,
						id: this.storeOrder.id
					}
				}
				// this.storeOrder
				this.$api.orderShipments(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false;
						this.loading=false
						this.storeOrderList();
					} else {
						this.$message.error(res.message);
						this.loading=false
					}
				})
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()

			},
			// 清空
			empty() {
				this.searchInfo = {}

			},
			storeOrderList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					username: this.searchInfo.username,
					userId: this.searchInfo.userId,
					orderSn: this.searchInfo.orderSn,
					status: this.searchInfo.status,
					brandId: this.searchInfo.brandId,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.getAllianceOrderList(data).then((res => {
					// console.log('联盟订单---',res.data.list)
					if (res.state == 'success') {
						this.orderList = res.data.list
						this.sliderlist = res.data
						// console.log(this.sliderlist)

					}
				}))
			},
			getAreasList(){
				//查询省
				this.$api.getAreasFive(0).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.provinceList = res.data
						//  console.log(this.provinceList)
					}
				})
			},
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.cityId = ""
				// this.setTLevelData.areaId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},

			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
			},
			// 订单详情查询
			showContent(e) {
				
				this.orderInfo = e
				// console.log(this.orderInfo)
				this.dialogVisible = true
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
			useeInfo(){
				this.$api.getUserInfo(this.$encrypt({})).then((res) => {
					// console.log('登录数据1---', res.data)
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('登录数据2---', res.data)
					if (res.state == 'success') {

						// storeId //不为0是店铺
						// this.storeInfo = res.data.store
						this.storeFlage = res.data.storeId==0?false:true;
					}
				})
			},
		},

		created() {
			this.useeInfo();
			this.storeOrderList();
			this.getAreasList();
		},
		mounted() {
			this.$api.sysExpressList({}).then((res) => {
				if (res.state == 'success') {
					this.sysExpressList = res.data.list
				}
			})
		}
	};
</script>

<style>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;

	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
        
	}
</style>
